import React from "react";

import _ from "underscore";
import { LinkButton, LabelIcon, Icomoon, LazyLoadImage, StarRating } from "../../../core/atoms/atoms";
import { isBrowser } from "../../../core/detection";
import * as styleVars from "../../../theme/exports.scss";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./trustCircularImage.scss";
import "./trustFiguresBlock.scss";

interface Props {
  country: ICountry;
}
interface State {
  windowWidth: number;
  listHeight: number;
}
class TrustFiguresBlock extends React.Component<Props, State>{

  private listRef = React.createRef<HTMLDivElement>();
  private recommendRating: number = 96;

  public constructor(props: Props) {
    super(props);
    this.state = {
      windowWidth: 0,
      listHeight: 0,
    };
  }

  private displayImage = () => {
    const dimension: string = `${(90 / 100) * this.state.listHeight}px`; // 90% of list height
    const imageSize = this.state.windowWidth >= parseInt(styleVars.widescreenWidth, 10) ? { width: dimension, height: dimension } : {};

    return (<div className="trust-circlular-image" style={imageSize}>
      <LazyLoadImage src="https://resources.travellocal.com/country-page/mt-fuji.jpg" alt="Mount Fuji at sunset" />
      <div className="trust-circlular-image-body">
        <h2>"Local knowledge does<br />make the difference!<br />Fantastic trip!"</h2>
        <div className="trust-circlular-image-icons">
          <LabelIcon icomoon={Icomoon.user} iconColor="light" labelTextColor="light" textSize="label" labelText="Alexandra" />
          <LabelIcon icomoon={Icomoon.location} iconColor="light" labelTextColor="light" textSize="label" labelText="UK" />
        </div>
      </div>
    </div>);
  }

  private displayList = () => (
    <ul>
      <li className="heading--">
        <i className="icon icon-checkmark" />
        <div>
          <span className="text--accent">{this.recommendRating}%</span> of all our customers would recommend us to a friend
        <div className="trust-figures-reviews">
            <StarRating currentValue={(this.recommendRating * 5) / 100} maximumValue={5} title={`Customer recommendation rating: ${this.recommendRating}%`} />
            <div className="trust-figures-button">
              <LinkButton to={WebRoutes.countryReviews(this.props.country.slug, this.props.country.parent.slug)} buttonClass="secondary-button">
                All reviews
            </LinkButton>
            </div>
          </div>
        </div>
      </li>

      <li className="heading--">
        <i className="icon icon-checkmark" />
        <div>
          The TravelLocal community is <span className="text--accent">18,000</span> strong
        </div>
      </li>

      <li className="heading--">
        <i className="icon icon-checkmark" />
        <div>
          We've hosted travellers from over <span className="text--accent">34</span> countries worldwide
        </div>
      </li>
    </ul>
  )

  private setDimensions = () => this.setState({ windowWidth: window.innerWidth, listHeight: this.listRef.current ? this.listRef.current.clientHeight : 0 });

  private handleResize = _.debounce(this.setDimensions, 200, false);

  public componentWillMount() {
    if (isBrowser()) {
      this.setDimensions();
    }
  }

  public componentDidMount() {
    const listHeight = this.listRef.current ? this.listRef.current.clientHeight : 0;
    this.setState({listHeight});
    window.addEventListener("resize", this.handleResize, false);
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  public render(): JSX.Element {
    const listWidth = this.state.windowWidth >= parseInt(styleVars.widescreenWidth, 10) ? { maxWidth: `calc(100% - ${this.state.listHeight}px)`} : {};

    return (
      <>
        <div className="trust-figures" ref={this.listRef} style={listWidth}>
        {
          this.displayList()
        }
        </div>

        {
          this.displayImage()
        }

      </>);
  }

}

export default TrustFiguresBlock;
